import { Component, OnChanges, OnInit } from '@angular/core';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import { SccStudyDataInterface } from 'src/app/scc/shared/services/scc-study-data.interface';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-scc-recycle-study-popup',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule, ReactiveFormsModule],
  templateUrl: './scc-recycle-study-popup.component.html',
  styleUrl: './scc-recycle-study-popup.component.scss'
})
export class SccRecycleStudyPopupComponent implements OnInit, OnChanges, IDialogContentComponent<number[], SccStudyDataInterface> {
  input?: SccStudyDataInterface;

  reviewer1FormControl: FormControl = new FormControl(false);
  reviewer2FormControl: FormControl = new FormControl(false);

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(): void {
  }

  getResult(): number[] {
    const selectedIds: number[] = [];

    if (this.reviewer1FormControl.value && this.input?.reviewer1) {
      selectedIds.push(this.input.reviewer1.id);
    }

    if (this.reviewer2FormControl.value && this.input?.reviewer2) {
      selectedIds.push(this.input.reviewer2.id);
    }

    return selectedIds;
  }


  isDisabled(): boolean {
    return false;
  }
}
